<ascedia-jumbotron [options]="jumbotron" *ngIf="jumbotron$ | async as jumbotron;"></ascedia-jumbotron>

<div class="container py-5" *ngIf="taBody$ | async as taBody;">
	<div [innerHTML]="taBody.body" class="content"></div>
</div>

